import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import ProductProductionForm from './ProductProductionForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'

const ProductProduction = ({ nameSingle, namePlural, separator, idProduct }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.product_production.get_product_production({
                p_id_product: idProduct
            }).then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.product_production.product_production_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idProduction) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idProduction } = $this.dataset

        Controllers.product_production.get_product_production_id({
            p_id_production: idProduction,
            p_id_product: idProduct
        }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idProduction}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.product_production.product_production_delete({
            ...dataDeleted,
            p_id_product: idProduct
        }).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idProduction, nameProduction } = e.currentTarget.dataset
        setDataDeleted({
            p_id_production: idProduction,
            p_name_production: nameProduction
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                /* { name: 'id_product', text: 'Id Producto', align: 'center' }, */
                {
                    name: 'order_n', text: 'Orden', align: 'center', render: r => {
                        return <div className='d-flex justify-content-center'>
                            <span>{r.order_n}</span>
                            {parseInt(r.order_n) > 1 && <i className="fas fa-arrow-up ml-3 align-self-center text-primary cur-pointer" onClick={_ => {
                                Controllers.product_production.product_production_order({
                                    p_id_product: r.id_product,
                                    p_id_production: r.id_production,
                                    p_type: 'down'
                                }).then(_ => {
                                    setReload(true)
                                })
                            }}></i>}
                            {parseInt(r.order_n) < rows.length && <i className="fas fa-arrow-down align-self-center text-danger ml-3 cur-pointer" onClick={_ => {
                                Controllers.product_production.product_production_order({
                                    p_id_product: r.id_product,
                                    p_id_production: r.id_production,
                                    p_type: 'up'
                                }).then(_ => {
                                    setReload(true)
                                })
                            }}></i>}
                        </div>
                    }
                },
                { name: 'key_product', text: 'Clave Component', align: 'center' },
                { name: 'name_product', text: 'Descripción' },
                { name: 'qty', text: 'Cantidad', align: 'center' },
                { name: 'new_qty', text: 'Conversión', align: 'center', render: r => {
                    if (parseInt(r.has_conversion) === 0) {
                        return <></>
                    }
                    return <>
                        <div>{r.qty_conversion} Piezas</div>
                        <div>equivalen a {r.qty} {r.code_product_unit}</div>
                    </>
                } },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            <Button variant="info" className="mr-1" size="xs" data-id-production={u.id_production} onClick={handleGet}>
                                <i className="fa fa-edit"></i>
                            </Button>
                            <Button variant="danger" size="xs" data-id-production={u.id_production} data-name-production={u.name_product} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button>
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Añadir {nameSingle}
                </Button>
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProductProductionForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} idProduct={idProduct} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_production} - {dataDeleted.p_name_production}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

ProductProduction.defaultProps = {
    idProduct: ''
}

export default ProductProduction